import { Component, OnInit } from '@angular/core';
import { ParameterService } from '../../services/parameter.service';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.css']
})
export class BottomNavComponent implements OnInit {

  year: number;

  constructor(public parameterService: ParameterService) {
    this.year = new Date().getFullYear();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/bottom-nav/bottom-nav.component.ts